import { render, staticRenderFns } from "./ClientRoleForm.vue?vue&type=template&id=1d4ddef9&scoped=true&"
import script from "./ClientRoleForm.vue?vue&type=script&lang=js&"
export * from "./ClientRoleForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4ddef9",
  null
  
)

export default component.exports